import { environment } from '../../../environments/environment';
import { BrowserCacheLocation, Configuration, IPublicClientApplication, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Policy } from '../models/policy';
import { Group } from '../models/group';
import { authConfig } from 'main';

export function MSALInstanceFactory(): IPublicClientApplication {
    const msalConfig: Configuration = {
        auth: {
            clientId: authConfig.clientId!,
            authority: authConfig.authority!,
            redirectUri: authConfig.redirectUrl!,
            postLogoutRedirectUri: authConfig.redirectUrl,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            loggerOptions: {
                loggerCallback: (logLevel: any, message: any) => {
                    // console.log(message);
                },
                piiLoggingEnabled: false,
                logLevel: LogLevel.Info
            }
        }
    };

    return new PublicClientApplication(msalConfig);
}


export function MsalGuardConfigurationFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [authConfig.scope!]
        },
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(authConfig.graphUrl + '/me/memberOf', ['user.read']);
    protectedResourceMap.set(environment.gatewayApiUrl + "/api/di/v1/*", [authConfig.scope!]);
    protectedResourceMap.set(environment.gatewayApiUrl + "/api/solver/v1/*", [authConfig.scope!]);
    protectedResourceMap.set(environment.gatewayApiUrl + "/api/monitoring/v1/*", [authConfig.scope!]);
    protectedResourceMap.set(environment.gatewayApiUrl + "/api/data-stream-message/v1/*", [authConfig.scope!]);
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

export function CreatePolicyConfiguration(groups: Group[]): Policy[] {
    let policies: Policy[] = new Array();

    // for adding needed policies

    return policies;
}